import Loading from 'react-simple-loading';

const Loader = () => {

    return (
        <div style={{ height: '80vh' }}>
            <Loading />
        </div>
    );

}

export default Loader